module.exports = __webpack_public_path__ + "img/fast.8c420f48.svg";